import { register } from '!/repository'
import { model as sessionModel } from '$/session'
import { combine, createEvent, sample } from 'effector'
import { liveEventsPurchasedEntityModel } from '~/entities/live-events/purchased'
import { model as showsEntityModel } from '~/entities/shows'
import { nay } from '~/shared/helpers'
import { libraryGridPurchasedLiveEventsWidget } from '~/widgets/library/grid/purchased/liveEvents'
import { $libraryPurchasedLiveEventsTranslations } from './translations'

export const initLibraryPurchasedLiveEventsPage = createEvent()
export const leftLibraryPurchasedLiveEventsPage = createEvent()

sample({
  clock: initLibraryPurchasedLiveEventsPage,
  target: libraryGridPurchasedLiveEventsWidget.loadGridPurchasedLiveEvents,
})

export const $isLibraryPurchasedLiveEventsEmptyPage = combine(
  liveEventsPurchasedEntityModel.$purchasedLiveEventsGrid,
  (purchasedLiveEventsGrid) =>
    purchasedLiveEventsGrid && !purchasedLiveEventsGrid.content.length
)

sample({
  source: leftLibraryPurchasedLiveEventsPage,
  target: liveEventsPurchasedEntityModel.resetPurchasedLiveEventsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: liveEventsPurchasedEntityModel.resetPurchasedLiveEventsGrid,
})

register(
  $libraryPurchasedLiveEventsTranslations,
  '$libraryPurchasedLiveEventsTranslations'
)
register(
  liveEventsPurchasedEntityModel.$purchasedLiveEventsGridFormatted,
  '$library/purchased/liveEvents/purchasedLiveEventsGridFormatted'
)
register(
  $isLibraryPurchasedLiveEventsEmptyPage,
  '$isLibraryPurchasedLiveEventsEmptyPage'
)
register(showsEntityModel.updateTvShow, 'updateTvShow')
register(
  libraryGridPurchasedLiveEventsWidget.loadMoreGridPurchasedLiveEvents,
  'loadMoreGridPurchasedLiveEvents'
)
